import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { SetErrorModal } from "../actions/global";
import { ApiError } from "../types/errors";
import i18n from "../i18n/config";

const isApiError = (err: unknown): err is ApiError =>
  typeof err === "object" && err !== null && "data" in err;

/** The server's first error message, else the generic copy — what ApiErrorModal shows. */
export const getApiErrorMessage = (err?: unknown): string => {
  if (!isApiError(err)) return i18n.t("COMMON.ERROR");
  return err.data?.errors?.[0]?.errorMessage ?? i18n.t("COMMON.ERROR");
};

const useErrorModal = () => {
  const dispatch = useDispatch();

  // memoised so hooks can list it as a dependency without re-running every render
  return useCallback(
    (err?: unknown) => {
      dispatch(SetErrorModal({ open: true, errorMessage: getApiErrorMessage(err) }));
    },
    [dispatch]
  );
};

export default useErrorModal;